import React from 'react'
import { FormGroup, Label, Input, } from 'reactstrap'
import PropTypes from 'prop-types'

/**
 * Provides options for creating usernames
 * while uploading a data CSV. 
 */
function UsernameOptions ({
  toggleUsernameOptions,
  studentUsernames,
  teacherUsernames,
}) {
  return (
    <div>
      <FormGroup check>
        <Label check>
          <Input 
            type='checkbox' 
            onChange={() => toggleUsernameOptions('student')}  
            checked={studentUsernames}
          />{' '}
          Generate student usernames
        </Label>
      </FormGroup>
      <FormGroup check>
        <Label check>
          <Input 
            type='checkbox' 
            onChange={() => toggleUsernameOptions('teacher')}
            checked={teacherUsernames}
          />{' '}
          Generate teacher usernames
        </Label>
      </FormGroup>
    </div>
  )
}

const { func, bool } = PropTypes
UsernameOptions.propTypes = {
  toggleUsernameOptions: func.isRequired,
  studentUsernames: bool.isRequired,
  teacherUsernames: bool.isRequired,
}

export default UsernameOptions


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/UsernameOptions.js